import { useState } from 'preact/hooks';
import { TicketIcon } from './TicketIcon';
import type { CameraChoice, HudStore } from './store';

const CAMERAS: { id: CameraChoice; label: string }[] = [
  { id: 'director', label: 'Director' },
  { id: 'leader', label: 'Leader' },
  { id: 'overview', label: 'Overview' },
  { id: 'finish', label: 'Finish line' },
];

export function Controls({ store }: { store: HudStore }) {
  // Phones show volume, Calm effects and Fullscreen behind a More button; wider screens show them all (hud.css).
  const [more, setMore] = useState(false);
  const cam = store.camera.value;
  const open = store.bets.value.filter((b) => b.status === 'active').length;
  const pick = (id: CameraChoice) => { store.camera.value = id; if (id !== 'follow') store.followed.value = null; };
  const fullscreen = () => {
    if (document.fullscreenElement) void document.exitFullscreen();
    else void document.documentElement.requestFullscreen?.().catch(() => {});
  };
  return (
    <nav class="panel controls" aria-label="Camera and settings">
      <div class="group cams" role="group" aria-label="Camera">
        {CAMERAS.map((c) => (
          <button key={c.id} type="button" class={cam === c.id ? 'on' : ''} aria-pressed={cam === c.id} onClick={() => pick(c.id)}>{c.label}</button>
        ))}
        {cam === 'follow' && <span class="following-note">Following cat</span>}
      </div>
      <div class={`group settings${more ? ' more-open' : ''}`} role="group" aria-label="Settings">
        <button type="button" class="sound" aria-label="Sound" aria-pressed={!store.muted.value} onClick={() => { store.muted.value = !store.muted.value; }}>
          {store.muted.value ? '🔇' : '🔊'}<span class="label">{store.muted.value ? ' Sound off' : ' Sound on'}</span>
        </button>
        <button type="button" class={`bets-btn${store.betsOpen.value ? ' on' : ''}`} aria-pressed={store.betsOpen.value} onClick={() => store.togglePanel('bets')}><TicketIcon /> Bets{open ? <span class="count-dot">{open}</span> : null}</button>
        <button type="button" class={`stats-btn${store.historyOpen.value ? ' on' : ''}`} aria-pressed={store.historyOpen.value} onClick={() => store.togglePanel('history')}>📊 Stats</button>
        <button type="button" class="more" aria-expanded={more} aria-controls="more-settings" onClick={() => setMore(!more)}>{more ? '✕ Less' : '⋯ More'}</button>
        <div class="extra" id="more-settings">
          <label class="volume" title="Sound volume">
            <input type="range" min="0" max="100" step="1" value={Math.round(store.volume.value * 100)}
              aria-label="Volume" onInput={(e) => store.setVolume(Number((e.currentTarget as HTMLInputElement).value) / 100)} />
          </label>
          <button type="button" class={store.restrained.value ? 'on' : ''} aria-pressed={store.restrained.value} onClick={() => { store.restrained.value = !store.restrained.value; }}>Calm effects</button>
          {document.fullscreenEnabled && <button type="button" class="fullscreen" onClick={fullscreen}>⛶ Fullscreen</button>}
        </div>
      </div>
    </nav>
  );
}
